import React, { useState } from 'react';
import styled from 'styled-components';
import { Pagination as AntPagination } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import useTranslation from '@src/hooks/useTranslation';
import useMediaQuery from '@src/hooks/useMediaQuery';

const TeachesPagination = styled(AntPagination)`
	.ant-pagination-item-ellipsis {
		font-family: 'Noto Sans', sans-serif !important;
	}

  .ant-pagination-total-text {
    font-size: 16px;
  }

	.ant-pagination-item-active{
		background: ${props => props.theme.colors.primary};
		border: 1px solid ${props => props.theme.colors.primary};
		& > a {
			color: #fff;
			font-size: 16px;
		}
	}
	.ant-pagination-item{
		& > a {
			font-size: 16px;
		}
	}

	.ant-select-item-option {
		background: #FFFFFF !important;
		color: #676767 !important;
		&:hover {
			color: ${props => props.theme.colors.primary} !important;
		}
		&.ant-select-item-option-selected {
			background: #E7F4F9 !important;
			color: #222222 !important;
		}
	}

	.ant-select:hover {
		& > .ant-select-selector {
			border: 1px solid ${props => props.theme.colors.primary} !important;
			& > .ant-select-selection-item {
				color: ${props => props.theme.colors.primary} !important;
			}
		}
	}

	.ant-select-open .ant-select-selector {
		border: 1px solid #DDDDDD !important;
	}

	.ant-select-selector {
    font-size: 16px;
		height: 32px !important;
		& > .ant-select-selection-search-input {
			height: 32px !important;
		}
		& > .ant-select-selection-item {
			line-height: 32px !important;
		}
	}
`;

interface IPagination extends PaginationProps {
	unit?: string;
	className?: string;
}

const Pagination = ({
	className,
	unit,
	current,
	total,
	defaultPageSize,
	onShowSizeChange,
	...props
}: IPagination): JSX.Element => {
	const { t } = useTranslation();
	const { mediaMatch: { isLgDesktop, isDesktop, isTablet } } = useMediaQuery();
	const [pageSize, setPageSize] = useState(defaultPageSize);
	return (
		<TeachesPagination
			total={total}
			defaultPageSize={defaultPageSize}
			className={className}
			showLessItems={!(isLgDesktop || isDesktop || isTablet)}
			onShowSizeChange={(currentPage, size) => {
				if (onShowSizeChange) onShowSizeChange(currentPage, size);
				setPageSize(size);
			}}
			showTotal={totalItem => {
				if (isLgDesktop || isDesktop || isTablet) {
					return t('pagination:total_style_large', {
						thisPage: current,
						totalPage: Math.ceil(totalItem / pageSize),
						unit,
						total: totalItem,
					});
				} else {
					return t('pagination:total_style_small', {
						unit,
						total,
					});
				}
			}}
			current={current}
			{...props}
		/>
	);
};

export default Pagination;
